var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"titulo my-4 px-4"},[_c('h1',{staticClass:"font-weight-bold",class:_vm.esMovil ? 'text-h6' : 'text-h5'},[_vm._v("\n            Politica sobre las Cookies\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }